import { createRouter, createWebHistory } from 'vue-router'
import PageDashboardCopa from 'pages/PageDashboardCopa.vue'

const routes = [
  {
    path: '/',
    name: 'dashboardCopa',
    component: PageDashboardCopa,
  },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
})

export default router
